import React, { useEffect } from 'react';
import { MobileView } from 'react-device-detect';
import { Outlet } from 'react-router-dom';

import MenuInferior from 'Component/MenuInferior';
import MenuSuperior from 'Component/MenuSuperior';
import RolarParaTopo from 'Component/RolarParaTopo';
import { alternarInterface } from 'Reducer/Config';
import { useAppDispatch, useAppSelector } from 'Store';

import type { Props } from './index';

const Default = (props: Props): React.ReactElement => {
  const dispatch = useAppDispatch();
  const exibirMenu = useAppSelector((estado) => estado.config.exibirMenu);
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  useEffect(() => {
    if (!exibirMenu) {
      dispatch(alternarInterface());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-black d-flex mh-100 flex-nowrap bg-light animate__animated animate__fadeIn">
      <div className="w-100 d-flex flex-column overflow-auto">
        <MenuSuperior />
        <section className="d-flex flex-column flex-grow-1">
          <RolarParaTopo />
          {props.children}
          <Outlet />
        </section>
        {usuario && (
          <MobileView>
            <MenuInferior />
          </MobileView>
        )}
        <div style={{ marginBottom: '67px' }} />
      </div>
    </div>
  );
};

export default Default;
